import { useState } from "react";
import { getNextClassSuggestion } from "../lib/api/endpoints";
import type { NextClassSuggestionDto } from "../types";
import { Button } from "./Button";
import { C } from "../theme";

export function NextClassSuggestion({ token, classId }: { token: string; classId: string }) {
  const [suggestion, setSuggestion] = useState<NextClassSuggestionDto | null | undefined>();
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try { setSuggestion(await getNextClassSuggestion(token, classId)); } finally { setLoading(false); }
  };

  return <div style={{ display: "grid", gap: 4 }}>
    <Button variant="ghost" onClick={() => void load()} disabled={loading}>{loading ? "Buscando…" : "Sugerir próxima aula"}</Button>
    {suggestion === null && <span style={{ color: C.light, fontSize: 11 }}>Nenhuma próxima aula disponível.</span>}
    {suggestion && <span style={{ color: C.gray, fontSize: 11 }}>Próxima: {suggestion.name} · {new Date(`${suggestion.date}T12:00:00`).toLocaleDateString("pt-BR")} · {suggestion.startTime.slice(0, 5)} — {suggestion.endTime.slice(0, 5)} · {suggestion.availableSpots} vagas</span>}
  </div>;
}
